const CONSTANTS = {

  BUILDING_USAGE: {
    bu1: {
      name: 'Comercial',
      value: 1.2,
    },
    bu2: {
      name: 'Residencial Vivienda',
      value: 0.75,
    },
    bu3: {
      name: 'Hospitalario',
      value: 1.1,
    },
    bu4: {
      name: 'Residencial Público',
      value: 1.15,
    },
    bu5: {
      name: 'Administrativo',
      value: 1,
    },
    bu6: {
      name: 'Docente',
      value: 1,
    },
    bu7: {
      name: 'Pública Concurrencia',
      value: 1.25,
    },
    bu8: {
      name: 'Garaje Aparcamiento',
      value: 1,
    },
  },

  PROJECT_TYPE: {
    pt1: {
      name: 'Prestacional',
      value: 0.40,
      min_price: 300,
    },
    pt2: {
      name: 'Prescriptivo',
      value: 0.15,
      min_price: 150,
    },
  },

  PROPERTY: {
    PROMOTIONAL_MSG: 'PROMOTIONAL_MSG',
  },

  PAGE_SIZE: 'paginationPageSize',

  COOKIES_ACCEPTED: 'cookies_accepted',

  VERSION: {
    V1: {
      name: 'V1',
      title: 'MEREDICTE© versión 1.0',
      nParams: 76,
    },
    V2: {
      name: 'V2',
      title: 'MEREDICTE© versión 2.0',
      nParams: 82, // 79 - 1 (ca7) + 4 (av, af, ah, H)
    },
  },

  VERSIONS: ['V1', 'V2'],

};

export { CONSTANTS }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/config/constants.config.js